// src/components/CookieBanner.jsx

import React, { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("teamkitty_cookie_consent");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("teamkitty_cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#111827",
        color: "#fff",
        padding: "16px",
        zIndex: 9999,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.2)",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
        }}
      >
        <div style={{ flex: 1, minWidth: "250px", fontSize: "14px" }}>
          TeamKitty uses essential cookies and similar technologies to keep the
          app secure, manage logins, process payments, and improve functionality.
          By continuing to use TeamKitty, you agree to this use.
        </div>

        <button
          onClick={acceptCookies}
          style={{
            background: "#22c55e",
            border: "none",
            color: "#fff",
            padding: "10px 18px",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}